import { defaultCtx } from "~/lib/AjaxCtx"

export default class NewsService {
    async getNewsItem(newsId) {
        return await defaultCtx.fetchData(`/news/${newsId}`, {
            method: "GET",
        })
    }
}
